import { Box, Grid, Typography, Slider } from "@mui/material";
import { Pill } from "./SettingsPills";
import { useTranslation } from "react-i18next";
import MultiButton from "./buttons/MultiButton";
import Info from "./Info";

/**
 * componente absolute per mostrare la legenda su mappa
 * @param {legendTitle, labels:[{title, actionButtons:{value, buttons}}]} 
 * @returns 
 */
export default function MapLegend({ legendTitle, labels: buttonLabels = [], sliderLabels = [], actionButton}) {
    const { t } = useTranslation();

    return (
        <Box sx={{
            p: 0.5,
            position: 'absolute',
            zIndex: 1,
            //marginTop: 'calc(16px + 3em)',
            width: { md: '30vw', xs: 'calc(100vw - 96px)' },
            minWidth: { md: '34em' },
        }}>
            <Pill lg={12} open={true} detailsHeight={'30vh'} pill={{
                id: 0,
                title: legendTitle,
                component: <Grid container direction="column">
                    {
                        buttonLabels.map(
                            (label, i) => <div key={`${label}-${i}-btn-container`}>
                                <Typography variant="subtitle1">{label.title}</Typography>
                                {
                                    label.actionButtons &&
                                    <MultiButton
                                        value={label.actionButtons.value}
                                        buttons={label.actionButtons.buttons}
                                    >
                                    </MultiButton>}
                            </div>
                        )
                    }
                    {
                        sliderLabels.map((slider, i) => (
                            <div key={`${slider}-${i}-sldr-container`}>
                                <Typography variant="subtitle1">{slider.title}</Typography>
                                <Slider
                                    sx={{width:'90%'}}
                                    value={slider.value}
                                    onChange={(e, newRange) => {
                                        slider.onChange(newRange);
                                    }}
                                    valueLabelDisplay="auto"
                                    marks={slider.marks}
                                />
                            </div>
                        ))
                    }
                    {actionButton}
                </Grid>
            }} index={0} />
        </Box>
    )
}